import { CommonData } from '@/components/blockEditor/blockEditor.types';
import { migrateCommonData } from '@/components/blockEditor/parseCommonData';

import {
  getDefaultEducationTitle,
  STATE_TAX_ITEMS,
  StateTaxEducationSlideType,
} from '../Education.constants';
import stateTaxEducationSlideConfigs from './StateTaxEducationSlides.defaults.json';

const configsByTitle = new Map(
  stateTaxEducationSlideConfigs.map((config) => [config.displayName, config])
);

export const DEFAULT_STATE_TAX_EDUCATION_SLIDES = Object.fromEntries(
  STATE_TAX_ITEMS.map((slideId) => {
    const title = getDefaultEducationTitle(slideId);
    const config = title ? configsByTitle.get(title) : undefined;
    if (!config) {
      throw new Error(`Missing default content for ${slideId}`);
    }

    const { blocks, version } = config.contentJSON;

    return [
      slideId,
      migrateCommonData({ blocks, version } as unknown as CommonData),
    ] as const;
  })
) as Record<StateTaxEducationSlideType, CommonData>;
